import { RESULTS } from "./data";
import { Container, MaskText, Reveal, Overline, LimeButton, ArrowDot, scrollToId } from "./primitives";

const Card = ({ r, i, big = false }) => (
  <Reveal delay={i * 0.08} className="h-full">
    <div className={`group relative flex h-full flex-col justify-between overflow-hidden rounded-[24px] p-6 transition-transform duration-500 hover:-translate-y-1 sm:p-8 ${big ? "min-h-[360px] bg-[#CCFF00] text-[#060B19] lg:min-h-full" : "min-h-[200px] border border-white/10 bg-[#0C142A] text-white hover:border-[#CCFF00]/40"}`}
      data-testid={`result-card-${i}`}>
      <div className={`font-mono-x text-[11px] uppercase tracking-[0.2em] ${big ? "text-[#060B19]/70" : "text-slate-400"}`}>{r.c}</div>
      <div>
        <div className={`font-display font-extrabold leading-none tracking-[-0.05em] ${big ? "text-[96px] sm:text-[140px]" : "text-5xl text-white sm:text-6xl"}`}>{r.v}</div>
        <div className={`mt-3 text-sm font-semibold ${big ? "" : "text-slate-300"}`}>{r.l}</div>
      </div>
      {!big && <span className="absolute right-6 top-6 h-2 w-2 rounded-full bg-[#CCFF00] opacity-0 transition-opacity duration-500 group-hover:opacity-100" />}
    </div>
  </Reveal>
);

export const Results = () => {
  const [first, ...rest] = RESULTS;
  return (
    <section id="resultados" className="grain relative bg-[#060B19] py-20 text-white lg:py-32" data-testid="results-section">
      <Container>
        <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
          <div>
            <Overline dark>Resultados</Overline>
            <MaskText className="font-display mt-6 text-4xl font-bold leading-[1] tracking-[-0.035em] sm:text-6xl lg:text-7xl"
              lines={["Resultados que", <>contam <span className="text-[#CCFF00]">histórias.</span></>]} />
          </div>
          <Reveal><p className="max-w-sm text-base leading-relaxed text-slate-300">Indicadores reais de projetos conduzidos com o método. Cada número representa uma empresa que passou a crescer com direção.</p></Reveal>
        </div>
        <div className="mt-14 grid gap-4 lg:grid-cols-12 lg:gap-5">
          <div className="lg:col-span-5"><Card r={first} i={0} big /></div>
          <div className="grid gap-4 sm:grid-cols-2 lg:col-span-7 lg:gap-5">
            {rest.map((r, i) => <Card key={r.v} r={r} i={i + 1} />)}
          </div>
        </div>
        <Reveal className="mt-12">
          <LimeButton onClick={() => scrollToId("contato")} data-testid="results-cta">Quero impulsionar meus resultados <ArrowDot /></LimeButton>
        </Reveal>
      </Container>
    </section>
  );
};
